import { createContext } from 'react';

export const TableSearchContext = createContext();
